import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IStatesApiClient } from './i-states-api.client';
import {
  ICreateStateRequest,
  IStateResponse,
  IUpdateStateReqeust,
} from '../dtos';
import { IPaginationResponse, ISoftDeletablePaginationParameters } from '../../../data-access';
import { ICreateStateResponse } from '../dtos/responses/create.state.response';
import { statesData } from '../data';
import { citiesData } from '../../cities/data';
import { ICityResponse } from '../../cities/dtos';


@Injectable({
  providedIn: 'root'
})
export class StatesInMemoryApiClient implements IStatesApiClient {
  constructor(protected http: HttpClient) {}

  get(
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<IStateResponse>> {
    return of(statesData.statesResponse);
  }

  getById(id: string): Observable<IStateResponse> {
    return of(statesData.stateResponse);
  }

  create(request: ICreateStateRequest): Observable<ICreateStateResponse> {
    return of(statesData.createStateResponse);
  }

  update(id: string, request: IUpdateStateReqeust): Observable<void> {
    return of();
  }

  getCities(
    stateId: string,
    paginationParameters?: ISoftDeletablePaginationParameters
  ): Observable<IPaginationResponse<ICityResponse>> {
    return of(citiesData.citiesResponse);
  }
}
